import { createPlan, getPlans } from "Services/api/neosmail/neosmail";
import { ServiceSubscription } from "Shared/ServiceSubscription/ServiceSubscription";

export function NeosMail() {
  return <ServiceSubscription serviceName="NeosMail" getPlans={getPlans} createPlan={createPlan} />;
}
